export default __webpack_public_path__ + "static/media/5.23ccfc52.png";